import React from 'react';
import cl from './MyButton_1.module.css'


const MyButton_1 = ({children, ...props}) => {
    return ( 
        <button {...props} className={cl.myBtn}>
            {children}
        </button>
    )
};

export default MyButton_1;
